export default __webpack_public_path__ + "static/media/app-analysis.6d18e513.jpg";